import { matter } from '../../api/matter';
import { BrowserFourdApi } from '.';
import { BaseRequest } from 'api';

export class Matter implements matter.Api {
  constructor(private fourd: BrowserFourdApi) {}

  openTable(request: matter.OpenTableRequest): void {
    if (request == null) {
      request.order = 1;
    }
    this.fourd.call4Dv2('matter.openTable', request);
  }

  openMatter(request: matter.OpenMatterRequest): void {
    this.fourd.call4Dv2('matter.openMatter', request);
  }

  selectMatter(request?: matter.SelectMatterRequest): Promise<matter.Matter[]> {
    return this.fourd.twoWayCall<matter.SelectMatterRequest, matter.Matter[]>(
      request,
      (requestId, request) => {
        this.fourd.call4Dv2('matter.selectMatter', request, requestId);
      },
      (response) => {
        if (
          !this.fourd.leapContext?.hostInfo?.hostVersion ||
          this.fourd.leapContext.hostInfo.hostVersion < '2.4.280.0'
        ) {
          //HSDK-122, fix the incorrect property names, can be removed when minimum version is 2.4
          return response.map((r) => {
            const matter = { ...r, deleted: r.delete, matterTypeId: '' };
            delete matter.delete;

            return matter;
          });
        }

        return response;
      }
    );
  }

  // getLists(request: BaseRequest): Promise<matter.MatterResult[]> {
  //   return this.fourd.twoWayCall<BaseRequest, matter.MatterResult[]>(
  //     request,
  //     (requestId, request) => {
  //       this.fourd.call4Dv2('matter.getLists', request, requestId);
  //     },
  //     (response) => {
  //       let responseData;
  //       try {
  //         responseData = JSON.parse(response.body);
  //       } catch (e) {
  //         // Unable to parse response => response is not a stringify object
  //         responseData = response;
  //       }
  //       return responseData;
  //     }
  //   );
  // }
}
